<ng-container *ngIf="DataSource$ | async as DataSource">
    <!-- ADD FILES BUTTON -->
    <!-- <div class="d-flex flex-row justify-content-end">
        <a class="btn btn-sm btn-icon btn-success mb-5" *ngIf="selectedFiles.length != 0 && DataSource.multiple"
            onclick="onInputClick()"
            (change)="onFileSelected($event)">
            <i class="fa-regular fa-add"></i>
        </a>
    </div> -->
    <!-- FILES -->

    <div class="upload-dropzone-container"
     [class.dragging]="isDragging"
     *ngIf="selectedFiles.length === 0"
     (drop)="onDrop($event)"
     (dragover)="onDragOver($event)"
     (dragleave)="onDragLeave($event)"
     (click)="onInputClick()">

    <input
        type="file"
        class="d-none"
        [id]="DataSource.elementId"
        [multiple]="DataSource.multiple"
        (change)="onFileSelected($event)" />

    <div class="dropzone-content">
        <i class="fa-duotone fa-upload upload-icon mb-2"></i>
        <p class="title mb-1">
            Arraste e solte os arquivos aqui
        </p>
        <p class="subtitle">
            ou clique para procurar
        </p>
    </div>
</div>

    <div *ngIf="selectedFiles.length > 0" [style.display]="'none !important'" class="file-upload mb-5 d-flex flex-column justify-content-center align-items-center"
        (click)="onInputClick()"
        (change)="onFileSelected($event)">
        <input type="file" class="file-input" [id]="DataSource.elementId" [multiple]="DataSource.multiple">
    </div>
    <table class="files-table table" *ngIf="selectedFiles.length > 0">
        <thead>
            <tr class="fs-7">
                <th class="w-60px"></th>
                <th>{{"lib.FILE_NAME" | translate}}</th>
                <th *ngIf="DataSource.showType" class="min-w-200px">{{"lib.FILE_TYPE" | translate}}</th>
                <th class="text-center">{{"lib.SIZE_MAX_6MB" | translate}}</th>
                <th class="w-80px">{{"lib.ACTIONS" | translate}}</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let customFile of selectedFiles; let i = index" [formGroup]="filesForm.controls.files.controls[i]" class="align-middle fs-7">
                <td class="text-center w-60px">
                    <i class="fs-4 fa-fw" [class]="getFileIcon(getFileExtension(customFile.name))"></i>
                </td>
                <td>
                    <ng-container *ngIf="editingIndex !== i;">
                        {{ customFile.name }}
                        <!--<i class="fa-regular fa-pencil ms-2 text-hover-success" (click)="startEditing(i)"></i>-->
                    </ng-container>

                    <ng-container *ngIf="editingIndex == i;" [formGroup]="filesForm.controls.files.controls[i]">
                        <input type="text"
                        class="form-control form-control-sm"
                        style="border:1px solid lightgray;"
                        formControlName="name"
                        [ngModel]="customFile.name"
                        (blur)="finishEditing(i)"
                        (keyup.enter)="finishEditing(i)" />
                    </ng-container>
                </td>
                <td *ngIf="DataSource.showType" class="text-center">
                    <mat-select class="form-control form-control-solid form-control-sm" style="border: 1px solid lightgray;" (selectionChange)="onFileTypeChange($event,i)"
                    [(value)]="customFile.type">
                        <mat-option *ngFor="let fileType of DataSource.fileTypes?.slice()?.reverse()" [value]="fileType.id">
                            {{ fileType.description }}
                        </mat-option>
                    </mat-select>
                </td>
                <td class="text-center"
                    [class.text-success]="(customFile.file?.size ?? 0) < 6 * 1024 * 1024"
                    [class.text-danger]="(customFile.file?.size ?? 0) >= 6 * 1024 * 1024">
                    {{ customFile.file ? ((customFile.file.size / (1024 * 1024)) | number: '.2-2') + ' MB' : '-' }}
                </td>
                <td class="w-80px">
                    <a class="action-icon d-flex justify-content-center align-items-center table-btn" type="button" (click)="removeFile(customFile.name)">
                        <i class="fa-regular fa-xmark"></i>
                    </a>
                </td>
            </tr>
        </tbody>
    </table>
</ng-container>
